export async function downloadFileFromUrl(url, fileName) {
  if (!url) throw new Error("No URL provided for download");

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.status}`);
    }

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName || url.split("/").pop();
    document.body.appendChild(a);
    a.click();
    a.remove();

    // revoke object url after a short delay to ensure download started
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    return true;
  } catch (err) {
    // If fetch fails (often due to CORS), fallback to letting browser handle the URL directly.
    // This will open the URL in a new tab/window and let the browser download it.
    try {
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      document.body.appendChild(a);
      a.click();
      a.remove();
      return true;
    } catch (err2) {
      throw err;
    }
  }
}

export function printPdfFromUrl(url) {
  if (!url) throw new Error("No URL provided for print");

  const printWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (!printWindow) {
    throw new Error("Popup blocked while opening PDF for print");
  }

  setTimeout(() => {
    try {
      printWindow.focus();
      printWindow.print();
    } catch {
      // Ignore print failures so the PDF viewer still opens.
    }
  }, 1200);

  return true;
}

export function printPdfFromBase64(base64Data) {
  if (!base64Data) throw new Error("No base64 data provided for print");

  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" });
  const blobUrl = URL.createObjectURL(blob);

  const printWindow = window.open(blobUrl, "_blank", "noopener,noreferrer");
  if (!printWindow) {
    throw new Error("Popup blocked while opening PDF for print");
  }

  setTimeout(() => {
    try {
      printWindow.focus();
      printWindow.print();
    } catch {
      // Ignore print failures so the PDF viewer still opens.
    }
  }, 1200);

  setTimeout(() => URL.revokeObjectURL(blobUrl), 300000);
  return true;
}

export default downloadFileFromUrl;
